/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { CreateCaseEditTimeMonitorEntryResponseJson } from './create-case-edit-time-monitor-entry-response-json';
import { CaseEditTimeMonitorEntryResult } from '../results/case-edit-time-monitor-entry-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class CreateCaseEditTimeMonitorEntryResponse extends ResponseWithErrorGeneric<CreateCaseEditTimeMonitorEntryResponseJson, CaseEditTimeMonitorEntryResult> implements IResponseWithErrorGeneric<CaseEditTimeMonitorEntryResult> {
  public clearanceCaseId: string = undefined;

  //<custom-body>
  constructor(response: HttpResponse<CreateCaseEditTimeMonitorEntryResponse>) {
    super(response, CaseEditTimeMonitorEntryResult.Error);
    if (this.result === CaseEditTimeMonitorEntryResult.Success) {
      this.clearanceCaseId = this.body.clearanceCaseId;
        }
  }
  //</custom-body>
}
